import React from "react";

const CompanySizeCard = ({
  label,
  subLabel,
  value,
  icon,
  isChecked,
  handleCheck,
}) => {
  return (
    <div
      className={`
      flex-1 mx-auto cursor-pointer rounded-lg border-1.5 py-5 px-3  justify-end flex flex-col
      transition-colors relative
      ${
        isChecked
          ? "border-secondary bg-[#207C9708] dark:bg-secondary-950/20"
          : "border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:border-gray-300 dark:hover:border-gray-700"
      }
    `}
      onClick={() => handleCheck(value)}
    >
      <div className="mb-1 flex items-start ">
        <div
          className={`flex-1 justify-start my-2.5 ${
            isChecked ? "text-secondary" : "text-gray-700 dark:text-gray-300"
          }`}
        >
          {icon}
        </div>
      </div>
      <div className="font-semibold text-xs text-gray-800 dark:text-gray-100">{label}</div>
      <div className="text-xs font-normal text-gray-500 dark:text-gray-400">{subLabel}</div>

      <div className="absolute top-5 right-3.5">
      <input
          type="checkbox"
          checked={isChecked}
          onChange={() => handleCheck(value)}
          onClick={(e) => e.stopPropagation()}
          className={`
    h-[14px] w-[14px] mb-2 border border-gray-300 rounded appearance-none
    transition-all duration-300 ease-in-out
    ${isChecked ? "bg-secondary border-secondary" : "bg-white dark:bg-gray-800"}
    relative flex items-center justify-center
    after:content-['✓']
    after:text-[9px] after:text-white after:font-bold
    after:transition-transform after:duration-300
    after:scale-0
    ${isChecked ? "after:scale-100 after:opacity-100" : "after:opacity-0"}
  `}
        />
      </div>
    </div>
  );
};

export default CompanySizeCard;
